import * as actionTypes from "../actions";
const initialState = {};

export function currenciesReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_CURRENCIES:
      return (state = action.payload);
    default:
      return state;
  }
}

export default currenciesReducer;
